import React from 'react';
import NavigateLink from '../navigateLink/navigateLink';
import classes from './Shourtcut.module.css';

const Shourtcut = ({ shourtcut }) => {

    return (
        <NavigateLink link={shourtcut?.link}>
            <div className={classes.ToolIcon} onClick={(e) => e.stopPropagation()}>
                <img src={shourtcut?.imageUrl} alt={shourtcut?.title} className={classes.ToolImage} />
            </div>
        </NavigateLink>
    );
};

export default Shourtcut; 